import React, { useState, useEffect } from 'react';

// ===== SWIPER PARA CARRUSEL =====
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// ===== ICONOS =====
import {
  FaBolt,
  FaCoins,
  FaUsers,
  FaRocket,
  FaShieldAlt,
  FaCube,
  FaCalendarAlt,
  FaHeart,
  FaLeaf,
  FaArrowRight
} from 'react-icons/fa';

// ===== ESTILOS E IMAGEN =====
import '../styles/AboutPage.css';
import reanimeitorBanner from '../Assets/banner-reanimeitor.jpg';

const AboutPage = () => {
  const [isMobile, setIsMobile] = useState(false);

  // DETECTAR MÓVIL
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // STATS PARA CARRUSEL
  const statsData = [
    {
      value: '2025',
      label: 'Fundación',
      icon: <FaCalendarAlt />,
      color: '#ffcc00',
      description: 'Nacimiento de Reanimeitor'
    },
    {
      value: '2.4K+',
      label: 'Clientes',
      icon: <FaUsers />,
      color: '#60a5fa',
      description: 'Comunidad en crecimiento'
    },
    {
      value: '21M',
      label: 'Tokens BGP',
      icon: <FaCoins />,
      color: '#10b981',
      description: 'Suministro total'
    }
  ];

  // VALORES PARA CARRUSEL
  const valuesData = [
    {
      icon: <FaBolt />,
      title: 'Energía',
      description: 'Potenciamos tu día con la mejor fórmula energética, diseñada para rendimiento máximo y sabor excepcional.',
      color: '#ffcc00',
      gradient: 'linear-gradient(135deg, #ffcc00, #ff9900)',
      points: [
        'Fórmula premium',
        'Rendimiento máximo',
        'Sabor excepcional'
      ]
    },
    {
      icon: <FaRocket />,
      title: 'Innovación',
      description: 'Integramos tecnología blockchain para crear experiencias únicas que conectan el mundo físico con el digital.',
      color: '#60a5fa',
      gradient: 'linear-gradient(135deg, #60a5fa, #3b82f6)',
      points: [
        'Blockchain en cada lata',
        'Tokens BGP gratuitos',
        'Trazabilidad NFC'
      ]
    },
    {
      icon: <FaUsers />,
      title: 'Comunidad',
      description: 'Creemos en el poder de las comunidades unidas por objetivos comunes y una visión compartida del futuro.',
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #10b981, #059669)',
      points: [
        'Más de 2,400 miembros',
        'Gobernanza participativa',
        'Eventos exclusivos'
      ]
    }
  ];

  // EQUIPO - ACTUALIZADO CON FOTOS
  const teamMembers = [
    {
      photo: require('../Assets/sergio.png'),
      initials: 'SP',
      name: 'Sergio Pérez Hidalgo',
      role: 'Fundador & CEO',
      bio: 'Visionario y emprendedor, fundador de Reanimeitor. Experto en integración de tecnología blockchain con productos físicos.',
      color: '#ffcc00',
      fullName: 'Sergio Pérez Hidalgo'
    },
    {
      photo: require('../Assets/daniel.png'),
      initials: 'DF',
      name: 'Daniel Fuentes Espuis',
      role: 'Programador & Ingeniero Informático',
      bio: 'Arquitecto de software especializado en Solana y contratos inteligentes. Desarrollador principal del token BGP.',
      color: '#60a5fa',
      fullName: 'Daniel Fuentes Espuis'
    },
    {
      photo: require('../Assets/joseluis.png'),
      initials: 'JF',
      name: 'Jose Luis Fuentes Sánchez',
      role: 'Director de Tecnología',
      bio: 'Responsable de la infraestructura tecnológica y desarrollo de sistemas. Experto en seguridad y escalabilidad.',
      color: '#10b981',
      fullName: 'Jose Luis Fuentes Sánchez'
    }
  ];

  // HITOS DE LA EMPRESA - SOLO 2
  const milestones = [
    {
      year: '2025',
      title: 'Fundación',
      description: 'Nace Reanimeitor con la visión de revolucionar las bebidas energéticas integrando tecnología blockchain.',
      icon: '🚀',
      completed: true,
      details: 'Sergio Pérez Hidalgo funda la compañía con la misión de conectar el mundo físico con el digital.'
    },
    {
      year: '2026',
      title: 'Primer Lanzamiento',
      description: 'Lanzamiento oficial de Reanimeitor Clásico con token BGP incluido 1:1 en cada compra.',
      icon: '⚡',
      completed: false,
      details: 'Fecha prevista para el lanzamiento al público. Cada lata incluirá 1 token BGP gratis.'
    }
  ];

  return (
    <div className="about-page">

      {/* ===== EFECTOS ELÉCTRICOS DE FONDO ===== */}
      <div className="energy-field">
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-node"></div>
        <div className="energy-node"></div>
        <div className="energy-node"></div>
        <div className="energy-node"></div>
        <div className="energy-wave"></div>
      </div>

      {/* ===== HERO SECTION ===== */}
      <section className="about-hero">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-icon">⚡</span>
            <span className="badge-text">DESDE 2025</span>
          </div>

          <h1 className="hero-title">
            <span className="title-line">Sobre</span>
            <span className="title-line-gradient">Nosotros</span>
          </h1>

          <p className="hero-description">
            Revolucionando el mundo de las bebidas energéticas con tecnología blockchain
            y una comunidad apasionada por la innovación.
          </p>

          <div className="hero-tags">
            <span className="hero-tag">Bebida Energética</span>
            <span className="hero-tag">Blockchain</span>
            <span className="hero-tag">Solana</span>
            <span className="hero-tag">Comunidad</span>
          </div>
        </div>
      </section>

      {/* ===== STATS SECTION CON CARRUSEL EN MÓVIL ===== */}
      <section className="about-stats-section">
        <div className="stats-container">
          <div className="section-header-mini">
            <h2>Nuestra Historia en Números</h2>
            <div className="header-line-small"></div>
          </div>

          {isMobile ? (
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={16}
              slidesPerView={1.2}
              centeredSlides={true}
              pagination={{
                clickable: true,
                dynamicBullets: true
              }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false
              }}
              loop={true}
              className="stats-carousel"
            >
              {statsData.map((stat, index) => (
                <SwiperSlide key={index}>
                  <div className="stat-card-mobile">
                    <div className="stat-icon-wrapper" style={{ color: stat.color }}>
                      {stat.icon}
                    </div>
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-label">{stat.label}</div>
                    <div className="stat-description">{stat.description}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="stats-grid">
              {statsData.map((stat, index) => (
                <div key={index} className="stat-card">
                  <div className="stat-icon-wrapper" style={{ color: stat.color }}>
                    {stat.icon}
                  </div>
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                  <div className="stat-description">{stat.description}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ===== MISSION SECTION ===== */}
      <section className="mission-section">
        <div className="mission-content">
          <div className="mission-text">
            <div className="section-header-left">
              <h2>Nuestra Misión</h2>
              <div className="header-line-left"></div>
            </div>

            <p className="mission-highlight">
              Combinamos la energía física con el poder digital.
            </p>

            <p className="mission-description">
              Cada lata no solo te da ese impulso que necesitas, sino que también
              te acerca al futuro de los productos tokenizados. Creemos en un
              mundo donde todos los producto serán tokenizados.
            </p>

            <div className="mission-quote">
              <span className="quote-icon">"</span>
              <p>Por eso, cada Reanimeitor incluye tokens BGP gratuitos.</p>
            </div>

            <div className="mission-features">
              <div className="mission-feature">
                <FaBolt className="feature-icon" style={{ color: '#ffcc00' }} />
                <span>Energía Premium</span>
              </div>
              <div className="mission-feature">
                <FaCube className="feature-icon" style={{ color: '#60a5fa' }} />
                <span>Token BGP Incluido</span>
              </div>
              <div className="mission-feature">
                <FaUsers className="feature-icon" style={{ color: '#10b981' }} />
                <span>Comunidad en Crecimiento</span>
              </div>
            </div>
          </div>

          <div className="mission-image">
            <div className="image-wrapper">
              <div className="image-glow"></div>
              <img
                src={reanimeitorBanner}
                alt="Nuestra Misión"
                className="mission-img"
              />
              <div className="image-badge">
                <span>+2,400 Clientes</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== VALUES SECTION CON CARRUSEL EN MÓVIL ===== */}
      <section className="values-section">
        <div className="section-header">
          <h2>Nuestros Valores</h2>
          <div className="header-line"></div>
          <p className="section-subheader">
            Los pilares que guían cada decisión y cada lata que producimos
          </p>
        </div>

        {isMobile ? (
          <div className="values-carousel-container">
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={16}
              slidesPerView={1}
              pagination={{
                clickable: true,
                dynamicBullets: true
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false
              }}
              loop={true}
              className="values-carousel"
            >
              {valuesData.map((value, index) => (
                <SwiperSlide key={index}>
                  <div className="value-card-premium">
                    <div className="value-card-header" style={{ background: value.gradient + '20' }}>
                      <div className="value-icon-large" style={{ color: value.color }}>
                        {value.icon}
                      </div>
                      <h3 style={{ color: value.color }}>{value.title}</h3>
                    </div>
                    <div className="value-card-body">
                      <p className="value-description">{value.description}</p>
                      <div className="value-points">
                        {value.points.map((point, idx) => (
                          <div key={idx} className="value-point">
                            <span className="point-dot" style={{ background: value.color }}></span>
                            <span>{point}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <div className="values-grid-premium">
            {valuesData.map((value, index) => (
              <div key={index} className="value-card-premium">
                <div className="value-card-header" style={{ background: value.gradient + '15' }}>
                  <div className="value-icon-large" style={{ color: value.color }}>
                    {value.icon}
                  </div>
                  <h3 style={{ color: value.color }}>{value.title}</h3>
                </div>
                <div className="value-card-body">
                  <p className="value-description">{value.description}</p>
                  <div className="value-points">
                    {value.points.map((point, idx) => (
                      <div key={idx} className="value-point">
                        <span className="point-dot" style={{ background: value.color }}></span>
                        <span>{point}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* ===== MILESTONES SECTION - SOLO 2 CON CARRUSEL EN MÓVIL ===== */}
      <section className="milestones-section">
        <div className="section-header">
          <h2>Nuestro Camino</h2>
          <div className="header-line"></div>
        </div>

        <div className="milestones-container">
          {isMobile ? (
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={16}
              slidesPerView={1}
              pagination={{
                clickable: true,
                dynamicBullets: true
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false
              }}
              loop={true}
              className="milestones-carousel"
            >
              {milestones.map((milestone, index) => (
                <SwiperSlide key={index}>
                  <div className={`milestone-card-mobile ${milestone.completed ? 'completed' : 'upcoming'}`}>
                    <div className="milestone-icon" style={{
                      borderColor: milestone.completed ? '#ffcc00' : '#10b981',
                      color: milestone.completed ? '#ffcc00' : '#10b981'
                    }}>
                      {milestone.icon}
                    </div>
                    <span className="milestone-year">{milestone.year}</span>
                    <h3>{milestone.title}</h3>
                    <p>{milestone.description}</p>
                    <div className="milestone-details">
                      <p>{milestone.details}</p>
                    </div>
                    <span className="milestone-badge">
                      {milestone.completed ? '✓ COMPLETADO' : '⚡ PRÓXIMAMENTE'}
                    </span>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="milestones-grid">
              {milestones.map((milestone, index) => (
                <div key={index} className={`milestone-card ${milestone.completed ? 'completed' : 'upcoming'}`}>
                  <div className="milestone-icon" style={{
                    borderColor: milestone.completed ? '#ffcc00' : '#10b981',
                    color: milestone.completed ? '#ffcc00' : '#10b981'
                  }}>
                    {milestone.icon}
                  </div>
                  <span className="milestone-year">{milestone.year}</span>
                  <h3>{milestone.title}</h3>
                  <p>{milestone.description}</p>
                  <div className="milestone-details">
                    <p>{milestone.details}</p>
                  </div>
                  <span className="milestone-badge">
                    {milestone.completed ? '✓ COMPLETADO' : '⚡ PRÓXIMAMENTE'}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ===== TEAM SECTION CON FOTOS (ACTUALIZADO) ===== */}
      <section className="team-section">
        <div className="section-header">
          <h2>Nuestro Equipo</h2>
          <div className="header-line"></div>
          <p className="section-subheader">
            Conoce a las mentes brillantes detrás de Reanimeitor
          </p>
        </div>

        {isMobile ? (
          // VERSIÓN MÓVIL CON FOTOS
          <div className="team-carousel-container">
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={16}
              slidesPerView={1}
              pagination={{
                clickable: true,
                dynamicBullets: true
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false
              }}
              loop={true}
              className="team-carousel"
            >
              {teamMembers.map((member, index) => (
                <SwiperSlide key={index}>
                  <div className="team-card-mobile">
                    <div className="member-avatar-premium">
                      <img
                        src={member.photo}
                        alt={member.name}
                        className="member-photo"
                        style={{
                          width: '100%',
                          height: '100%',
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                      />
                    </div>
                    <h3 className="member-name">{member.name}</h3>
                    <div className="member-role" style={{ color: member.color }}>
                      {member.role}
                    </div>
                    <p className="member-bio">{member.bio}</p>
                    <div className="member-social">
                      <span className="social-dot" style={{ background: member.color }}></span>
                      <span className="social-dot" style={{ background: member.color }}></span>
                      <span className="social-dot" style={{ background: member.color }}></span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          // VERSIÓN ESCRITORIO CON FOTOS
          <div className="team-grid-premium">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card-premium">
                <div className="team-card-header" style={{ background: `linear-gradient(135deg, ${member.color}20, transparent)` }}>
                  <div className="member-avatar-premium">
                    <img
                      src={member.photo}
                      alt={member.name}
                      className="member-photo"
                      style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>
                </div>
                <div className="team-card-body">
                  <h3 className="member-name">{member.name}</h3>
                  <div className="member-role" style={{ color: member.color }}>
                    {member.role}
                  </div>
                  <p className="member-bio">{member.bio}</p>
                  <div className="member-social">
                    <span className="social-dot" style={{ background: member.color }}></span>
                    <span className="social-dot" style={{ background: member.color }}></span>
                    <span className="social-dot" style={{ background: member.color }}></span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* ===== CTA SECTION ===== */}
      <section className="cta-section-premium">
        <div className="cta-content">
          <div className="cta-badge">
            <FaBolt className="cta-badge-icon" />
            <span>ÚNETE A LA REVOLUCIÓN</span>
          </div>

          <h2>¿Listo para la Energía?</h2>
          <p>
            Únete a la revolución Reanimeitor y descubre cómo la energía
            puede transformar tu vida y tu futuro financiero.
          </p>

          <div className="cta-buttons-premium">
            <button className="cta-btn-primary" onClick={() => window.location.href = '/account'}>
              <span>Comprar Reanimeitor</span>
              <FaArrowRight className="btn-icon" />
            </button>
            <button className="cta-btn-secondary" onClick={() => window.location.href = '/account'}>
              <FaCoins className="btn-icon" />
              <span>Ver Tokens BGP</span>
            </button>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutPage;